<template>
<div class="chapter">
<div class="inner_page">
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<blockquote><p class="hang"><a id="pviii"></a> My vegetable love should grow</p></blockquote>
<blockquote><p class="hang">Vaster than empires and more slow . . .</p></blockquote>
<p class="timebreak"> <br/></p>
<blockquote><p class="hang">But at my back I always hear</p></blockquote>
<blockquote><p class="hang">Time’s winged chariot hurrying near . . .</p></blockquote>
<p class="timebreak"> <br/></p>
<blockquote><p class="right">—Andrew Marvell, “To His Coy Mistress”</p></blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front04.vue?0068d1e6